import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import {
  countDadosCadastrais,
  countScore,
  formatDocument,
  getColorScore,
  getImageURLScoreSerasa,
} from "../../../utils/utils";
import QuadroSocietario from "../../common/query/QuadroSocietario";
import ModalReceitaFederal from "../../modals/ModalReceitaFederal";

const SerasaBasicoQuery = ({ data, dataFull }) => {
  const totalScore = Array.isArray(dataFull)
    ? dataFull.reduce((acc, item) => acc + countScore(item), 0)
    : countScore(dataFull);

  const podeRenderizarScore = totalScore < 3;

  return (
    <>
      <>
        {" "}
        <TitleStripe>II - Dados Cadastrais</TitleStripe>
        {data?.dadosCadastrais?.cpf && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 text-sm border border-gray-200 rounded-xl overflow-hidden">
            {[
              { label: "Nome completo", value: data?.dadosCadastrais?.nome },
              {
                label: "CPF",
                value: formatDocument(data?.dadosCadastrais?.cpf),
              },
              {
                label: "Situação do CPF",
                value: data?.dadosCadastrais?.situacao,
                isStatus: true,
              },
              { label: "Nome da mãe", value: data?.dadosCadastrais?.nomeMae },
              {
                label: "Data de nascimento",
                value: data?.dadosCadastrais?.dataNascimento,
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`p-4 border-b border-gray-200 ${
                  (index + 1) % 3 === 0 ? "sm:border-r-0" : "sm:border-r"
                }`}
              >
                <p className="text-gray-500 text-xs mb-1">{item.label}</p>
                {item.isStatus ? (
                  <span
                    className={`font-semibold text-sm inline-block `}
                  >
                    {item.value || "Indisponível"}
                  </span>
                ) : (
                  <p className="font-medium text-gray-800">
                    {typeof item.value === "string"
                      ? item.value?.trim() || "Indisponível"
                      : item.value || "Indisponível"}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
        {data?.dadosCadastrais?.cnpj && (
          <div className="mt-4 grid grid-cols-2 gap-6 bg-white border border-gray-200 rounded-xl p-6 shadow-sm text-sm">
            <div className="space-y-4">
              <div>
                <div className="text-gray-500 text-xs uppercase">
                  Razão Social
                </div>
                <div className="font-medium text-gray-900">
                  {data?.dadosCadastrais?.razaoSocial || "Indisponível"}
                </div>
                <ModalReceitaFederal cnpj={data?.dadosCadastrais?.cnpj} />
              </div>

              <div>
                <div className="text-gray-500 text-xs uppercase">CNPJ/MF</div>
                <div className="font-medium text-gray-900">
                  {data?.dadosCadastrais?.cnpj
                    ? formatDocument(data?.dadosCadastrais?.cnpj)
                    : "Indisponível"}
                </div>
              </div>
            </div>

            <div className="space-y-10">
              <div>
                <div className="text-gray-500 text-xs uppercase">
                  Situação do CNPJ
                </div>
                <div
                  className={`inline-block text-xs font-semibold rounded-md`}
                >
                  {data?.dadosCadastrais?.situacao || "Indisponível"}
                </div>
              </div>
              <div className="mt-5">
                <div className="text-gray-500 text-xs uppercase">Fundação</div>
                <div className="font-medium text-gray-900">
                  {data?.dadosCadastrais?.dataFundacao || "Indisponível"}
                </div>
              </div>
            </div>
          </div>
        )}
        {data?.dadosCadastrais?.cpf && (
          <div>
            <TitleStripe className="mb-5">
              II - Participação em Empresas
            </TitleStripe>
            {data?.socios?.length > 0 ? (
              <ParticipacaoEmEmpresas empresas={data?.socios} />
            ) : (
              <NoOcurrence />
            )}
          </div>
        )}
        {data?.dadosCadastrais?.cnpj && (
          <div>
            <TitleStripe className="mb-5">II - Quadro Societário</TitleStripe>
            {data?.socios?.length > 0 ? (
              <QuadroSocietario
                socios={data?.socios?.map((socio) => ({
                  cpf_cnpj: socio?.cpf,
                  nome_empresa: socio?.nome,
                  participacao: socio?.percentualParticipacao,
                }))}
              />
            ) : (
              <NoOcurrence />
            )}
          </div>
        )}
      </>

      {podeRenderizarScore && (
        <div>
          <TitleStripe>Score</TitleStripe>
          <div className="grid grid-cols-2 gap-6 mt-4">
            {/* Card do Score com imagem e número */}
            <div className="flex flex-col items-center justify-center border rounded-xl bg-white shadow-sm p-6">
              <img
                src={getImageURLScoreSerasa(data?.score?.score)}
                alt="Score"
                className="h-24"
              />
              <div
                className="font-bold text-base text-white mt-4 px-6 py-2 rounded-full shadow"
                style={{ backgroundColor: getColorScore(data?.score?.score) }}
              >
                Score {data?.score?.score ?? "Não disponível"}
              </div>
            </div>

            {/* Card da Probabilidade */}
            <div className="flex items-center border border-gray-200 rounded-xl bg-gray-50 p-6 shadow-sm">
              <div className="text-gray-800 text-base">
                <p className="font-medium">Probabilidade de inadimplência:</p>
                <p className="text-4xl font-bold text-red-600 mt-1">
                  {data?.score?.probabilidadeInadimplencia != null
                    ? `${data?.score?.probabilidadeInadimplencia}%`
                    : "N/A"}
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  Esta métrica indica a chance estimada de que o cliente deixe
                  de cumprir com suas obrigações financeiras nos próximos 12
                  meses. Quanto maior o percentual, maior o risco associado à
                  concessão de crédito.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div>
        <TitleStripe className="mb-5">II - Pendências Financeiras</TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <>
            <PendenciasFinanceiras
              quantidadeTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal
              }
              valorTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
              }
              pendenciasFinanceiras={data?.pendenciasFinanceiras}
            />
          </>
        ) : (
          <NoOcurrence />
        )}

        <div>
          <TitleStripe className="mb-5">II - Títulos protestados</TitleStripe>
          {data?.protestos?.length > 0 ? (
            <Protestos
              quantidadeTotal={data?.resumoConsulta?.protestos?.quantidadeTotal}
              valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
              protestos={data?.protestos}
              temVencimento={false}
            />
          ) : (
            <NoOcurrence />
          )}
        </div>
      </div>

      <div>
        <TitleStripe className="mb-5">II - Cheques sem fundos</TitleStripe>

        {data?.chequesSemFundo?.length > 0 ? (
          <>
            <ChequesSemFundos chequesSemFundos={data?.chequesSemFundo} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>
    </>
  );
};

export default SerasaBasicoQuery;
